import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import eLiftEn from '../locales/en/elift.json';
import eLiftFr from '../locales/fr/elift.json';
//import about_en from './locales/en/about.json';
//import about_fr from './locales/fr/about.json';

const RESOURCES = {
    en: {
        elift: eLiftEn,
        //about: about_en,
    },
    fr: {
        elift: eLiftFr,
        //about: about_fr,
    },
};

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: RESOURCES,        
        fallbackLng: 'en', 
        defaultNS: 'elift',
        debug: process.env.NODE_ENV === 'development',
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;